export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Делегирование и постановка задач — обучение руководителей",
        "description": "Обучение руководителей делегированию и постановке задач: как правильно передавать ответственность, ставить задачи, контролировать исполнение и управлять без микроменеджмента. Корпоративные программы в Минске, Беларуси и онлайн.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Обучение делегированию и постановке задач",
        "description": "Корпоративное обучение руководителей делегированию и постановке задач: как правильно передавать ответственность, ставить задачи, контролировать исполнение, развивать самостоятельность сотрудников и управлять без микроменеджмента.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение руководителей, делегирование, постановка задач, контроль исполнения",
        "url": "https://business-training.by/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое делегирование и зачем оно нужно руководителю?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Делегирование — это передача задач и ответственности сотрудникам с сохранением общей ответственности руководителя за результат. Цель делегирования не в том, чтобы избавиться от работы, а в том, чтобы увеличить управленческую ёмкость руководителя, развить самостоятельность команды и высвободить время руководителя для стратегических задач."
            }
          },
          {
            "@type": "Question",
            "name": "Как правильно делегировать задачи сотрудникам?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Правильное делегирование включает: выбор подходящей задачи и сотрудника, чёткое описание ожидаемого результата, определение сроков, полномочий и критериев качества, договорённость о контрольных точках, проверку понимания задачи сотрудником и получение обратной связи. Важно не просто сказать «сделай это», а объяснить, какой результат нужен и почему."
            }
          },
          {
            "@type": "Question",
            "name": "Как правильно ставить задачи сотрудникам?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Качественная постановка задачи включает девять элементов: что необходимо получить, зачем это нужно, какой результат считается хорошим, к какому сроку, какие ограничения существуют, какие ресурсы доступны, какие полномочия получает сотрудник, когда и как проверяем промежуточный результат и как сотрудник понял задачу. Особенно важно проверить понимание задачи — попросить сотрудника своими словами сформулировать результат и следующие действия."
            }
          },
          {
            "@type": "Question",
            "name": "Как контролировать выполнение задач без микроменеджмента?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Контроль без микроменеджмента строится на заранее определённых контрольных точках. Руководитель контролирует результат в согласованные моменты, а не каждый шаг сотрудника. Количество контрольных точек зависит от сложности задачи и компетентности сотрудника. По мере роста самостоятельности сотрудника количество точек контроля можно уменьшать."
            }
          },
          {
            "@type": "Question",
            "name": "Какие задачи руководитель должен делегировать?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Делегировать можно задачи, которые: повторяются регулярно, не требуют уникальной компетенции руководителя, могут быть выполнены сотрудником с нужным уровнем подготовки, развивают компетенции сотрудника. Не стоит делегировать стратегические решения, задачи с высокими рисками в неопытные руки и ключевые коммуникации с важными партнёрами. Также важно не превращать делегирование в сброс неприятной работы."
            }
          },
          {
            "@type": "Question",
            "name": "Почему сотрудники не выполняют поставленные задачи?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Причины могут быть как в сотруднике, так и в системе делегирования: задача поставлена неясно, не определены критерии качества, отсутствуют сроки или они нереалистичны, сотрудник не получил необходимых полномочий или ресурсов, руководитель постоянно меняет требования, отсутствует обратная связь или сотрудник не принимает ответственность за результат."
            }
          },
          {
            "@type": "Question",
            "name": "Как научить руководителей делегировать?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение делегированию строится на практике: руководители разбирают свои реальные задачи, учатся выбирать задачи для делегирования, формулировать ожидаемый результат, определять критерии качества и контрольные точки. Отрабатывают постановку задач и проведение контрольных разговоров. Важно не только дать алгоритм, но и помочь преодолеть психологические барьеры: страх потери контроля, недоверие, привычку всё делать самому."
            }
          },
          {
            "@type": "Question",
            "name": "Чем делегирование отличается от передачи поручений?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Передача поручения — это указание выполнить конкретное действие: «сделай это». Делегирование — это передача задачи вместе с ответственностью за результат и полномочиями для её выполнения. При делегировании сотрудник понимает не только что делать, но и зачем, какой результат нужен и в каких рамках он может принимать решения самостоятельно."
            }
          },
          {
            "@type": "Question",
            "name": "Как повысить самостоятельность сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Самостоятельность развивается постепенно: от выполнения по инструкции к самостоятельным решениям. Важно давать сотруднику право на ошибку в рамках контролируемого риска, не забирать задачу обратно после первой ошибки, давать конструктивную обратную связь и постепенно увеличивать уровень ответственности по мере роста компетенции."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится тренинг по делегированию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Продолжительность зависит от задач компании и уровня участников. Корпоративный тренинг обычно длится 1–2 дня интенсивной практической работы. Модульная программа может занимать несколько недель с практикой между модулями. Точный формат и продолжительность определяются после диагностики потребностей компании."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под нашу компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап подготовки. Сначала разбираемся в реальных управленческих ситуациях компании, уровне участников и отраслевой специфике. После этого содержание программы настраивается так, чтобы участники работали с актуальными для них задачами по делегированию и постановке задач, а не с абстрактными примерами."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли проводить обучение руководителей онлайн?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, онлайн-формат доступен и эффективен для распределённых команд. Он удобен для модульных программ с практическими заданиями между встречами. Для интенсивной отработки навыков постановки задач и делегирования офлайн-формат зачастую даёт более высокую вовлечённость, поэтому оптимальным часто является смешанный формат: очные интенсивные сессии с онлайн-сопровождением."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}